export default class VideoHero {
  constructor() {
    this.hero = document.querySelector(".video-hero")

    this.video = this.hero ? this.hero.querySelector("video") : null
    this.videoToggle = this.hero ? this.hero.querySelector(".play-pause") : null
    this.videoToggleIcon = this.videoToggle
      ? this.videoToggle.querySelector(".play-pause__icon")
      : null
    this.videoToggleText = this.videoToggle
      ? this.videoToggle.querySelector(".play-pause__text")
      : null

    this.initVideo()
  }

  initVideo() {
    if (!this.video) return

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")

    if (!mediaQuery.matches) {
      this.video.play()
      this.videoToggleIcon.classList.remove("play-pause__icon--play")
      this.videoToggleText.textContent = "Pause Video"
    }

    this.videoToggle.addEventListener("click", () => {
      if (this.video.paused) {
        this.video.play()
        this.videoToggleIcon.classList.remove("play-pause__icon--play")
        this.videoToggleIcon.classList.add("play-pause__icon--pause")
        this.videoToggleText.textContent = "Pause Video"
      } else {
        this.video.pause()
        this.videoToggleIcon.classList.remove("play-pause__icon--pause")
        this.videoToggleIcon.classList.add("play-pause__icon--play")
        this.videoToggleText.textContent = "Play Video"
      }
    })
  }
}
